module.exports = __webpack_public_path__ + "src/img/clockbeats-orchestra/feature-large.36a10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/clockbeats-orchestra/feature-large.jpg
// module id = 240
// module chunks = 0